export { LandingPageXl } from "./LandingPageXl";
